import React, { useState } from "react";
import PropTypes from "prop-types";
import InfoCirclePurpleIcon from "../../../../assets/img/action-center/info-circle-purple.svg";
import ChevronDownSmallIcon from "../../../../assets/img/chevron_down_small.svg";
import ChevronUpSmallIcon from "../../../../assets/img/chevron_up_small.svg";
import {
  WARNING_BOLD,
  WARNING_REST,
  STACKING_HEADER_INLINE,
  STACK_TOGGLE_SHOW,
  STACK_TOGGLE_HIDE,
} from "../campaignConstants";
import "./CampaignStackInfo.scss";

const STACK_LIST_ID = "campaign-stack-info-list";

const CampaignStackInfo = ({ descriptions = [] }) => {
  const [isStackOpen, setIsStackOpen] = useState(true);
  const hasStack = Array.isArray(descriptions) && descriptions.length > 0;

  return (
    <div className="campaign-stack-info">
      <span className="campaign-stack-info-icon">
        <img src={InfoCirclePurpleIcon} alt="" />
      </span>
      <div className="campaign-stack-info-text">
        <p className="campaign-stack-info__warning">
          <strong>{WARNING_BOLD}</strong> {WARNING_REST}
        </p>

        {hasStack && (
          <div className="campaign-stack-info__stack">
            <p className="campaign-stack-info__stack-header">
              {STACKING_HEADER_INLINE}{" "}
              <button
                type="button"
                className="campaign-stack-info__toggle"
                aria-expanded={isStackOpen}
                aria-controls={STACK_LIST_ID}
                data-heap-id="campaign-stack-info-toggle"
                onClick={() => setIsStackOpen((open) => !open)}
              >
                {isStackOpen ? STACK_TOGGLE_HIDE : STACK_TOGGLE_SHOW}
                <img
                  src={isStackOpen ? ChevronUpSmallIcon : ChevronDownSmallIcon}
                  alt=""
                  className="campaign-stack-info__chevron"
                />
              </button>
            </p>
            {isStackOpen && (
              <div
                id={STACK_LIST_ID}
                className="campaign-stack-info__stack-body"
              >
                <ul>
                  {descriptions.map((description) => (
                    <li key={description}>{description}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

CampaignStackInfo.propTypes = {
  /** Chain breadcrumbs from the applicable-rates response, one line each. */
  descriptions: PropTypes.arrayOf(PropTypes.string),
};

export default CampaignStackInfo;
